import { WithTranslation, withTranslation } from 'react-i18next';
import * as React from 'react';
import { useState } from 'react';
import {
  Box,
  ModalMobileLayout,
  Loader,
  Modal,
  Text,
  TextButton,
  Button,
} from '@wix/design-system';

export interface CustomizedPayButtonProps extends WithTranslation {
  customizePayMethod: () => Promise<any>;
  backUrl: string;
  errorUrl: string;
}

const CustomizedPayButtonComp = ({
  customizePayMethod,
  backUrl,
  errorUrl,
  t,
}: CustomizedPayButtonProps) => {
  const [isPaidModalShown, showPaidModal] = useState(false);
  const [isBtnLoaderShown, showBtnLoader] = useState(false);

  const onPayClick = () => {
    showBtnLoader(true);
    customizePayMethod()
      .then((data) => {
        if (!data) {
          showPaidModal(true);
        }
      })
      .catch((e) => {
        console.error(e);
        window.location.href = errorUrl;
      })
      .finally(() => showBtnLoader(false));
  };

  const onClose = () => {
    showPaidModal(false);
    window.location.href = backUrl;
  };

  return (
    <Box marginTop="36px" paddingRight="8px">
      <TextButton size="medium" skin="light" onClick={onPayClick} fluid>
        <Box
          height="48px"
          backgroundColor="D10"
          align="center"
          verticalAlign="middle"
          width="100%"
          marginTop="10px"
        >
          {isBtnLoaderShown ? (
            <Loader color="white" size="small" />
          ) : (
            t('invoice.pay.submit.button')
          )}
        </Box>
      </TextButton>
      <Modal
        isOpen={isPaidModalShown}
        onRequestClose={() => {
          showPaidModal(false);
        }}
        shouldCloseOnOverlayClick
      >
        <Box maxWidth="510px">
          <ModalMobileLayout
            title={t('invoice.pay.paid-modal.title')}
            content={
              <Text weight="thin">{t('invoice.pay.paid-modal.message')}</Text>
            }
            footer={
              <Box align="right">
                <Button onClick={onClose}>
                  {t('invoice.pay.paid-modal.button')}
                </Button>
              </Box>
            }
            onCloseButtonClick={onClose}
          />
        </Box>
      </Modal>
    </Box>
  );
};

export const CustomizedPayButton = withTranslation()(CustomizedPayButtonComp);
